import { AnyAction, combineReducers } from "redux";
import { AppState } from "@shared/interfaces";
import { PayPerLeadReducer } from "@containers/PayPerLead/store/reducer";
import { ticketApi } from "@containers/Tickets/ticketApi";
import { investorFileApi, presetApi } from "@containers/Contact/api";
import { webhooksApi } from "@containers/Integrations/Webhooks/api";
import { apiKeysApi } from "@containers/Integrations/ApiKeys/api";
import { stateApi } from "@shared/api/stateApi";
import { countyApi } from "@shared/api/countyApi";
import { backTestingApi } from "@containers/BackTesting/backTestingApi";
import { leadSessionApi } from "@containers/PayPerLead/store/leadSessionApi";
import { reiSiftIntegrationApi } from "@shared/api/reiSiftIntegrationApi";
import { reiSiftApi } from "@shared/api/reiSiftApi";
import { exportableFilesApi } from "@shared/api/exportablFilesApi";
import { couponApi } from "@shared/api/couponApi";
import { deployListsApi } from "@shared/api/deployListsApi";
import { companyApi } from "@shared/api/companyApi";

import { AuthReducer } from "../containers/Auth/store/reducer";
import { reducer as FileReducer } from "../containers/File/store";
import { reducer as SkipTracingReducer } from "../containers/SkipTracing/store";
import { reducer as AccountReducer } from "../containers/Account/store";
import { reducer as ContactReducer } from "../containers/Contact/store";
import { reducer as InvestorFileReducer } from "../containers/InvestorFile/store";
import { reducer as PresetReducer } from "../containers/Preset/store";
import { reducer as ClaritasReducer } from "../containers/Claritas/store";
import { reducer as MarketMapReducer } from "../containers/MarketMap/store";
import { reducer as PresetBuilderReducer } from "../containers/PresetBuilder/store";
import { reducer as DataDeliveryReducer } from "../containers/DataDelivery/store";
import { reducer as NicheFilesReducer } from "../containers/NicheFiles/store";
import { reducer as PropertiesReducer } from "../containers/Properties/store";
import { SharedReducer } from "../shared/store/reducer";

export default () => {
  const appReducer = combineReducers({
    auth: AuthReducer,
    shared: SharedReducer,
    file: FileReducer,
    skipTracing: SkipTracingReducer,
    account: AccountReducer,
    client: ContactReducer,
    investorFile: InvestorFileReducer,
    preset: PresetReducer,
    claritas: ClaritasReducer,
    marketMap: MarketMapReducer,
    presetBuilder: PresetBuilderReducer,
    dataDelivery: DataDeliveryReducer,
    payPerLead: PayPerLeadReducer,
    nicheFiles: NicheFilesReducer,
    properties: PropertiesReducer,
    [ticketApi.reducerPath]: ticketApi.reducer,
    [deployListsApi.reducerPath]: deployListsApi.reducer,
    [presetApi.reducerPath]: presetApi.reducer,
    [investorFileApi.reducerPath]: investorFileApi.reducer,
    [webhooksApi.reducerPath]: webhooksApi.reducer,
    [apiKeysApi.reducerPath]: apiKeysApi.reducer,
    [stateApi.reducerPath]: stateApi.reducer,
    [leadSessionApi.reducerPath]: leadSessionApi.reducer,
    [countyApi.reducerPath]: countyApi.reducer,
    [backTestingApi.reducerPath]: backTestingApi.reducer,
    [reiSiftIntegrationApi.reducerPath]: reiSiftIntegrationApi.reducer,
    [reiSiftApi.reducerPath]: reiSiftApi.reducer,
    [exportableFilesApi.reducerPath]: exportableFilesApi.reducer,
    [couponApi.reducerPath]: couponApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
  });

  return (state: AppState | undefined, action: AnyAction) => {
    return appReducer(state, action);
  };
};
